import { ethers } from 'ethers'
import { ChainId } from './chainData'

export const SUPPORTED_CHAIN_IDS: number[] = [
  ChainId.ETHEREUM_MAINNET,
  // ChainId.ETHEREUM_TESTNET,
  ChainId.GOCHAIN_MAINNET,
  // ChainId.GOCHAIN_TESTNET,
]

// Read-only providers, used to query both chains regardless of which one
// MetaMask is connected to
export const GOCHAIN_CHAIN_ID = ChainId.GOCHAIN_MAINNET
export const gochainProvider = new ethers.providers.StaticJsonRpcProvider(
  'https://rpc.gochain.io:443',
  // 'https://testnet-rpc.gochain.io',
  GOCHAIN_CHAIN_ID
)
gochainProvider.pollingInterval = 12000

export const ETHEREUM_CHAIN_ID = ChainId.ETHEREUM_MAINNET
export const ethereumProvider = new ethers.providers.InfuraProvider(
  'homestead',
  '3cb45774c19e48fab8c36ebceab2c194'
)
ethereumProvider.pollingInterval = 12000
